import { axios } from "../../util/axiosConfig";
import { announcements } from "../urls";

const createAnnouncementHeart = (nick, id) =>
  axios
    .post(announcements.single + `/${id}/hearts/create`, { nick })
    .then(response => response.data);

export default createAnnouncementHeart;
